import React, { useState, useEffect } from "react";
import { useParams, useHistory, useLocation } from "react-router-dom";
import "./CoachProfilePage.css";
import ProfileTabView from "./Components/profileTabView/ProfileTabView";
import MeetingsTabView from "./Components/meetingTabView/MeetingTabView";
import StudentsTab from "./Components/studentTabView/StudentsTab";
import { getCoachDetailMock } from "./getCoachDetail.mock";
import {
  GetCoachDetail,
  GetCoachMeetings,
  GetCoachStudents,
} from "../../api/AdminCoachPanel/coachApis";
import { ToastContainer, toast } from "react-toastify";
import SideBar from "../../components/SideBar";
import { useMediaQuery } from "react-responsive";
import { Components } from "../../assets/Dimensions";

export default function CoachProfilePage() {
  const { coachId } = useParams();
  const history = useHistory();
  const location = useLocation();
  const user = JSON.parse(localStorage.getItem("user"));
  const userAdminToken = sessionStorage.getItem("jwtP");
  const [activeTab, setActiveTab] = useState("profile");
  const [coach, setCoach] = useState(null);
  const [loading, setLoading] = useState(true);
  const [nav, setNav] = useState(false);
  const [students, setStudents] = useState([]);
  const [studentsLoading, setStudentsLoading] = useState(false);
  const [meetings, setMeetings] = useState([]);
  const [meetingsLoading, setMeetingsLoading] = useState(false);

  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 700px)" });
  const CoachDetail = async (id) => {
    try {
      setLoading(true);

      const res = await GetCoachDetail(userAdminToken, id);

      if (res.data.ResponseStatus === 1) {
        const response = res.data.ResponseData;

        // Save raw
        setCoach(res.data.ResponseData);
      } else {
        toast.error("Koç  alınamadı.");
        history.push("/dashboard");
      }
    } catch (error) {
      console.error("Error fetching coaches:", error);
      toast.error("Bir hata oluştu, lütfen tekrar deneyiniz.");
    } finally {
      setLoading(false);
    }
  };

  const fetchCoachStudents = async () => {
    try {
      setStudentsLoading(true);

      const res = await GetCoachStudents(userAdminToken, coach.UserId);

      if (res.data.ResponseStatus === 1) {
        const rawStudents = res.data.ResponseData || [];
        const mappedStudents = rawStudents.map(function (s) {
          const hasEndDate =
            s.AssignmentEndDate !== null &&
            s.AssignmentEndDate !== undefined &&
            String(s.AssignmentEndDate).trim() !== "";

          return {
            Id: s.UserId,
            Name: (s.Name + " " + s.Surname).trim(),
            StartDate: s.AssignmentStartDate
              ? s.AssignmentStartDate.split("T")[0]
              : "-", // backend does not provide it
            EndDate: hasEndDate ? s.AssignmentEndDate.split("T")[0] : "-",
            Status: hasEndDate ? "Completed" : "Active",
          };
        });

        // Active first
        mappedStudents.sort(function (a, b) {
          if (a.status === b.status) return 0;
          return a.status === "Active" ? -1 : 1;
        });
        setStudents(mappedStudents);
      } else {
        setStudents([]);
      }
    } catch (err) {
      console.error("GetCoachStudents error", err);
      setStudents([]);
    } finally {
      setStudentsLoading(false);
    }
  };
  const fetchCoachMeetings = async () => {
    try {
      setStudentsLoading(true);

      const res = await GetCoachMeetings(userAdminToken, coach.UserId);

      if (res.data.ResponseStatus === 1) {
        const rawMeetings = res.data.ResponseData || [];
        // console.log("rawStudents",rawStudents);
        // const mappedStudents = rawStudents.map(function (s) {
        //   const hasEndDate = s.EndDate && s.EndDate.trim() !== "";

        //   return {
        //     id: s.UserId,
        //     name: s.NickName
        //       ? s.NickName
        //       : (s.Name + " " + s.Surname).trim(),
        //     startDate: s.StartDate,
        //     endDate: s.EndDate,
        //     status: hasEndDate ? "Completed" : "Active",
        //   };
        // });

        // // Active first
        // mappedStudents.sort(function (a, b) {
        //   if (a.status === b.status) return 0;
        //   return a.status === "Active" ? -1 : 1;
        // });

        const mappedMeetings = rawMeetings.map(function (m) {
          const dateObj = new Date(m.Date);

          return {
            id: m.MeetingId,
            date: dateObj.toISOString().split("T")[0],
            time: dateObj.toTimeString().slice(0, 5),
            studentName: (m.StudentName + " " + m.StudentSurname).trim(),
            studentId: m.StudentId,
            duration: "-", // backend not ready
            rating: "-", // backend not ready
            recordings: m.Recordings || [],
            title: m.Title,
          };
        });

        setMeetings(mappedMeetings);
      } else {
        setMeetings([]);
      }
    } catch (err) {
      console.error("GetCoachStudents error", err);
      setMeetings([]);
    } finally {
      setMeetingsLoading(false);
    }
  };

  useEffect(
    function () {
      if (activeTab === "students") {
        fetchCoachStudents();
      } else if (activeTab === "meetings") {
        fetchCoachMeetings();
      }
    },
    [activeTab, coachId]
  );

  useEffect(() => {
    CoachDetail(coachId);
  }, [coachId]);

  if (loading) {
    return <div style={{ padding: 24 }}>Loading coach profile…</div>;
  }

  if (!coach) {
    return <div style={{ padding: 24 }}>Coach not found</div>;
  }

  const profileData = {
    id: coach.Id,
    fullName: `${coach.Name} ${coach.Surname}`.trim(),
    avatar: coach.ProfilePictureUrl,
    university: coach.CoachDetail.UniversityName,
    major: coach.CoachDetail.MajorName,
    about: coach.CoachDetail.AboutMe,
    remainingSeats: coach.CoachDetail.RemainingSeats,
    badges: coach.CoachDetail.Badges || [],
    ranks: coach.CoachRanks || [],
    videoUrl: coach.CoachDetail.ProfileVideoUrl1,
    students: coach.Students || [],
    meetings: coach.Meetings || [],
    phoneNumber: coach.PhoneNumber,
    email: coach.Email,
  };

  // mock coach name for now (we’ll wire real data later)
  const coachName =
    location.state && location.state.coach
      ? `${location.state.coach.Name} ${location.state.coach.Surname}`
      : "Coach Profile";

  const profile = {
    about: "Experienced coach helping students reach top universities.",
    university: "Stanford University",
    major: "Computer Science",
    badges: ["TYT", "EA", "Zaman Yönetimi"],
    ranks: [
      { ExamSubType: "EA", Rank: "317" },
      { ExamSubType: "SAY", Rank: "11" },
    ],
  };
  return (
    <>
      {isTabletOrMobile ? (
        <div>
          <span
            style={{ position: "absolute", top: 10, right: 10 }}
            onClick={() => setNav(!nav)}
          >
            menu
          </span>
          {nav && <SideBar />}
        </div>
      ) : (
        <SideBar />
      )}
      <ToastContainer />
      <div
        className="coach-profile-page"
        style={{
          paddingLeft: isTabletOrMobile ? 15 : Components.SideBarWidth + 15,
        }}
      >
        {/* Breadcrumb */}
        <div className="coach-profile-breadcrumb">
          <span className="breadcrumb-link" onClick={() => history.push("/")}>
            Dashboard
          </span>
          <span className="breadcrumb-separator">/</span>
          <span
            className="breadcrumb-link"
            onClick={() => history.push("/CoachesAdminPanel")}
          >
            Coaches
          </span>
          <span className="breadcrumb-separator">/</span>
          <span className="breadcrumb-current">{profileData.fullName}</span>
        </div>

        {/* Main layout */}
        <div className="coach-profile-container">
          {/* LEFT COLUMN */}
          <div className="coach-profile-left">
            {/* Identity Card */}
            <div className="coach-profile-card coach-profile-identity">
              <div className="coach-profile-avatar">
                <img src={profileData.avatar} alt="Coach avatar" />
              </div>

              <h2 className="coach-profile-name">{profileData.fullName}</h2>

              <p className="coach-profile-meta">
                {profileData.university}/ {profileData.major}
              </p>

              <div className="coach-profile-badges">
                {profileData.badges.map(function (badge) {
                  return (
                    <span key={badge.Id} className="coach-profile-badge">
                      {badge.Name}
                    </span>
                  );
                })}
              </div>

              <div className="coach-profile-divider" />

              <div className="coach-profile-seats">
                <span className="coach-profile-seats-label">
                  Kalan kontenjan / Toplam Kontenjan
                </span>
                <span className="coach-profile-seats-value">
                  {coach.CoachDetail.TotalSeat -
                    coach.CoachDetail.RemainingSeats}
                  /{coach.CoachDetail.TotalSeat}
                </span>
              </div>
            </div>

            {/* Profile Video Card */}
            <div className="coach-profile-card">
              <h3 className="coach-profile-section-title">Profil Video</h3>

              <div className="coach-profile-video">
                <video
                  src={profileData.videoUrl}
                  controls
                  preload="metadata"
                  className="coach-profile-video-player"
                >
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>
          </div>

          {/* RIGHT COLUMN */}
          <div className="coach-profile-right">
            <div className="coach-profile-tabs-card">
              <div className="coach-profile-tabs">
                <button
                  className={
                    "coach-profile-tab " +
                    (activeTab === "profile" ? "active" : "")
                  }
                  onClick={() => setActiveTab("profile")}
                >
                  Profil
                </button>

                <button
                  className={
                    "coach-profile-tab " +
                    (activeTab === "meetings" ? "active" : "")
                  }
                  onClick={() => setActiveTab("meetings")}
                >
                  Toplantılar
                </button>

                {/* <button
        className={
          "coach-profile-tab " +
          (activeTab === "students" ? "active" : "")
        }
        onClick={() => setActiveTab("students")}
      >
        Students
      </button> */}

                {/* <button
        className={
          "coach-profile-tab " +
          (activeTab === "notes" ? "active" : "")
        }
        onClick={() => setActiveTab("notes")}
      >
        Notes
      </button> */}
              </div>
            </div>

            {/* TAB CONTENT PLACEHOLDER */}
            <div className="coach-profile-tab-content">
              {activeTab === "profile" && (
                <ProfileTabView profile={profileData} />
              )}

              {activeTab === "meetings" &&
                (meetingsLoading ? (
                  <div style={{ padding: 24 }}>Loading meetings…</div>
                ) : (
                  <MeetingsTabView meetings={meetings} />
                ))}

              {/* {activeTab === "students" && (
  studentsLoading ? (
    <div style={{ padding: 24 }}>Loading students...</div>
  ) : (
    <StudentsTab students={students} coachUserID = {coach.UserId}/>
  )
)} */}

              {/* {activeTab === "students" && <StudentsTab students={students}/>} */}

              {activeTab === "notes" && (
                <div className="coach-profile-card">
                  Notes content coming next…
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
